import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { iBisAuthModule } from '@dohu/ibis-auth';
import { iBisCommonModule } from '@dohu/ibis-common';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { BrowserModule } from '@angular/platform-browser';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxoSummaryModule, DxoValidationModule } from 'devextreme-angular/ui/nested';
import { RegisterComponent } from './register/register.component';
import { TermsAndConditionsComponent } from './terms/terms.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxValidationSummaryModule } from 'devextreme-angular/ui/validation-summary';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';

@NgModule({
	declarations: [
		RegisterComponent,
		UserProfileComponent,
		TermsAndConditionsComponent
	],
	imports: [
		CommonModule,
		DxFormModule,
		BrowserModule,
		iBisAuthModule,
		DxButtonModule,
		DxCheckBoxModule,
		DxoSummaryModule,
		DxTextBoxModule,
		DxValidationSummaryModule,
		DxValidationGroupModule,
		DxValidatorModule,
		iBisCommonModule,
	],
	exports: [
		RegisterComponent,
		UserProfileComponent,
		TermsAndConditionsComponent
	]
})
export class AccountModule { }
